export default __webpack_public_path__ + "static/media/team_naim.f82174c8.png";